<template>
    <aside class="main-sidebar">
        <!-- sidebar: style can be found in sidebar.less -->
        <div>
            <section class="sidebar">
                <!-- /.search form -->
                <!-- Sidebar user panel -->
                <!-- <div class="user-panel"> -->
                <!-- <div class="image"> <img src="static/img/avatar2.png" class="img-circle" alt="User Image"> </div> -->
                <!-- <div class="info">
                        <p>Good Job, Matirasa</p>
                        <p><small>You haven,t miss any task this week!</small></p>
                        <div> <a href="#"><i class="ti-panel"></i><small>Settings</small></a> <a href="#"><i class="ti-user"></i><small>Profile</small></a> <a href="#"><i class="ti-power-off"></i><small>Logout</small></a> </div>
                    </div> <img class="bg-user" src="static/img/avatar-bg.png" alt="User Image"> </div> -->
                <!-- sidebar menu: : style can be found in sidebar.less -->
                <ul class="sidebar-menu">
                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-location-pin "></i> <span>Lokasi</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li v-if="level === 'ROOT'">
                                <router-link to="/region"> <span>Region</span> </router-link>
                            </li>
                            <li v-if="level === 'ROOT'">
                                <router-link to="/wilayah"> <span>Wilayah</span> </router-link>
                            </li>
                            <li v-if="level === 'ROOT'">
                                <router-link to="/area/+/+"> <span>Area</span> </router-link>
                            </li>
                            <li v-if="level === 'ROOT'">
                                <router-link to="/cabang"> <span>Cabang</span> </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-user"></i> <span>Pegawai</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/pegawai_level"> Level / Jabatan</router-link>
                            </li>
                            <li>
                                <router-link to="/pegawai"> Data</router-link>
                            </li>
                            <li>
                                <router-link to="/absensi"> Absensi</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-dropbox"></i> <span>Barang</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/barang_satuan"> Satuan</router-link>
                            </li>
                            <li>
                                <router-link to="/barang_kelompok"> Kelompok</router-link>
                            </li>
                            <li>
                                <router-link to="/barang"> Data</router-link>
                            </li>
                            <li>
                                <router-link to="/barang_jadi"> Brg Jadi (FG)</router-link>
                            </li>
                            <li>
                                <router-link to="/barang_jadi_bahan"> B.O.M</router-link>
                            </li>
                            <li>
                                <router-link to="/barang_accurate"> ACCURATE</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-layout-grid3"></i> <span> Menu POS</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/menu_kategori"> Kategori</router-link>
                            </li>
                            <li>
                                <router-link to="/menu"> Data</router-link>
                            </li>
                        </ul>
                    </li>
                    <li v-if="level === 'ROOT'">
                        <router-link to="/investor"> <i class="ti-user"></i> <span>Investor</span> </router-link>
                    </li>
                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-home"></i> <span>Toko</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li v-if="level === 'ROOT'">
                                <router-link to="/toko_jenis"> Jenis</router-link>
                            </li>
                            <li v-if="level === 'ROOT'">
                                <router-link to="/toko_admin"> Admin</router-link>
                            </li>
                            <li>
                                <router-link to="/toko"> Data</router-link>
                            </li>
                            <li>
                                <router-link to="/barang_toko"> Barang</router-link>
                            </li>
                            <li>
                                <router-link to="/toko_pegawai"> Pegawai</router-link>
                            </li>
                            <li>
                                <router-link to="/toko_device"> Device POS</router-link>
                            </li>
                            <li>
                                <router-link to="/menu_toko"> Menu Toko</router-link>
                            </li>
                            <li>
                                <router-link to="/investor_toko"> Investor Toko</router-link>
                            </li>
                            <li>
                                <router-link to="/pemesanan_barang">Pemesanan Barang</router-link>
                            </li>
                            <li>
                                <router-link to="/penjualan">Penjualan</router-link>
                            </li>
                            <li>
                                <router-link to="/penjualan_input">Input Penjualan</router-link>
                            </li>
                            <li>
                                <router-link to="/laporan_harian">Laporan Penjualan</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_harian">Pengeluaran Harian</router-link>
                            </li>
                            <li>
                                <router-link to="/pnl">PNL</router-link>
                            </li>
                            <li>
                                <router-link to="/kacab_fee">Fee Kacab</router-link>
                            </li>
                            <li>
                                <router-link to="/toko_dashboard">Dashboard</router-link>
                            </li>
                            <li>
                                <router-link to="/toko_infaq">Infaq</router-link>
                            </li>
                            <li>
                                <router-link to="/penerimaan_barang">Penerimaan Barang</router-link>
                            </li>
                            <li>
                                <router-link to="/toko_target">Target</router-link>
                            </li>
                            <li>
                                <router-link to="/toko_pinjam_barang">Pinjam Barang</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-money"></i> <span>Pengeluaran</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/pengeluaran_bulanan_pilihan"> Pilihan</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_cogs"> COGS</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_opr"> OPR</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_sum"> Summary</router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-wallet"></i> <span>Saving</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li v-if="level === 'ROOT'">
                                <router-link to="/saving_pilihan"> Pilihan</router-link>
                            </li>
                            <li>
                                <router-link to="/saving"> Data</router-link>
                            </li>
                        </ul>
                    </li>

                    <li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="el-icon-date "></i> <span>Cutoff</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li v-if="level === 'ROOT'">
                                <router-link to="/cutoff_jenis"> <span>Jenis</span> </router-link>
                            </li>
                            <li v-if="level === 'ROOT'">
                                <router-link to="/cutoff_detail"> <span>Detail</span> </router-link>
                            </li>
                        </ul>
                    </li>

					<li class="treeview" v-if="level === 'ROOT'">
                        <a href="#"> <i class="ti-truck"></i> <span>Pengiriman</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li v-if="level === 'ROOT'">
                                <router-link to="/armada"> <span>Armada</span> </router-link>
                            </li>
                            <li v-if="level === 'ROOT'">
                                <router-link to="/pengiriman"> <span>Data</span> </router-link>
                            </li>
                        </ul>
                    </li>
					
					
					<!-- MENU ADMIN STARTS FROM HERE -->
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/toko"> <i class="ti-home"></i> <span>Toko / Store</span> </router-link>
                    </li>
                    <li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/toko_device"> <i class="ti-tablet"></i> <span>Device POS</span> </router-link>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/barang_toko"> <i class="ti-dropbox"></i> <span>Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('ADMIN') !== -1">
                        <!-- <router-link to="/toko_pegawai"> <i class="ti-user"></i> <span>Pegawai</span> </router-link> -->
                        <a href="#"> 
                            <i class="ti-user"></i>
                            <span>Pegawai</span>
                            <span class="pull-right-container">
                                <i class="fa fa-angle-left pull-right"></i>
                            </span> 
                        </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/pegawai"> Master Data</router-link>
                            </li>
                            <li>
                                <router-link to="/toko_pegawai"> Per Toko</router-link>
                            </li>
                        </ul>
                    </li>
					<!-- <li v-if="level.indexOf('ADMIN') !== -1">
                        <router-link to="/menu_toko"> <i class="ti-layout-grid3"></i> <span>Menu</span> </router-link>
                    </li> -->
					<li class="treeview" v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <a href="#"> 
                            <i class="ti-layout-grid3"></i>
                            <span>Menu</span>
                            <span class="pull-right-container">
                                <i class="fa fa-angle-left pull-right"></i>
                            </span> 
                        </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/barang_jadi"> Barang Jadi</router-link>
                            </li>
                            <li>
                                <router-link to="/menu"> Master Data</router-link>
                            </li>
                            <li>
                                <router-link to="/menu_toko"> Per Toko</router-link>
                            </li>
                        </ul>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/pemesanan_barang"> <i class="ti-pencil"></i> <span>Pemesanan Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/penerimaan_barang"> <i class="ti-truck"></i> <span>Penerimaan Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/toko_pinjam_barang"> <i class="ti-reload"></i> <span>Pinjam Barang</span> </router-link>
                    </li>
					<!-- <li v-if="level.indexOf('ADMIN') !== -1">
                        <router-link to="/penjualan"> <i class="ti-shopping-cart"></i> <span>Penjualan</span> </router-link>
                    </li> -->
					<li class="treeview" v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <a href="#"> <i class="ti-shopping-cart"></i> <span>Penjualan</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/penjualan"> Data</router-link>
                            </li>
                            <li>
                                <router-link to="/penjualan_input"> Input</router-link>
                            </li>
                        </ul>
                    </li>
					<li class="treeview" v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <a href="#"> <i class="ti-shopping-cart-full"></i> <span>Pengeluaran</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/pengeluaran_harian"> Harian</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_cogs"> Bulanan COGS</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_opr"> Bulanan OPR</router-link>
                            </li>
                        </ul>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/saving"> <i class="ti-wallet"></i> <span>Saving</span> </router-link>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/laporan_harian"> <i class="ti-write"></i> <span>Laporan</span> </router-link>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/pnl"> <i class="ti-bar-chart"></i> <span>PnL</span> </router-link>
                    </li>
					<li v-if="level.indexOf('ADMIN TOKO') !== -1">
                        <router-link to="/toko_dashboard"> <i class="ti-pie-chart"></i> <span>Dashboard</span> </router-link>
                    </li>
					<!-- <li v-if="level.indexOf('ADMIN') !== -1">
                        <router-link to="/excel"> <i class="ti-files"></i> <span>Excel</span> </router-link>
                    </li> -->

                    
                    <!-- MENU BOD STARTS FROM HERE -->
					<li v-if="level.indexOf('BOD') !== -1">
                        <router-link to="/penjualan"> <i class="ti-shopping-cart"></i> <span>Penjualan</span> </router-link>
                    </li>
					<li v-if="level.indexOf('BOD') !== -1">
                        <router-link to="/toko_dashboard"> <i class="ti-pie-chart"></i> <span>Dashboard</span> </router-link>
                    </li>
					<li v-if="level.indexOf('BOD') !== -1">
                        <router-link to="/pnl"> <i class="ti-bar-chart"></i> <span>PnL</span> </router-link>
                    </li>

					
					<!-- MENU KACAB STARTS FROM HERE -->
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/toko"> <i class="ti-home"></i> <span>Toko / Store</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/barang_toko"> <i class="ti-dropbox"></i> <span>Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/toko_pegawai"> <i class="ti-user"></i> <span>Pegawai</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/penerimaan_barang"> <i class="ti-truck"></i> <span>Penerimaan Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/toko_pinjam_barang"> <i class="ti-reload"></i> <span>Pinjam Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/penjualan"> <i class="ti-shopping-cart"></i> <span>Penjualan</span> </router-link>
                    </li>
					<li class="treeview" v-if="level.indexOf('KACAB') !== -1">
                        <a href="#"> <i class="ti-shopping-cart-full"></i> <span>Pengeluaran</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/pengeluaran_harian"> Harian</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_cogs"> Bulanan COGS</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_opr"> Bulanan OPR</router-link>
                            </li>
                        </ul>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/saving"> <i class="ti-wallet"></i> <span>Saving</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/laporan_harian"> <i class="ti-write"></i> <span>Laporan</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/pnl"> <i class="ti-bar-chart"></i> <span>PnL</span> </router-link>
                    </li>
					<li v-if="level.indexOf('KACAB') !== -1">
                        <router-link to="/toko_dashboard"> <i class="ti-pie-chart"></i> <span>Dashboard</span> </router-link>
                    </li>

                    <!-- MENU AM STARTS FROM HERE -->
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/cabang"> <i class="ti-location-pin"></i> <span>Cabang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/toko"> <i class="ti-home"></i> <span>Toko / Store</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/barang_toko"> <i class="ti-dropbox"></i> <span>Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/toko_pegawai"> <i class="ti-user"></i> <span>Pegawai</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/penerimaan_barang"> <i class="ti-truck"></i> <span>Penerimaan Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/toko_pinjam_barang"> <i class="ti-reload"></i> <span>Pinjam Barang</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/penjualan"> <i class="ti-shopping-cart"></i> <span>Penjualan</span> </router-link>
                    </li>
					<li class="treeview" v-if="level.indexOf('AM') !== -1">
                        <a href="#"> <i class="ti-shopping-cart-full"></i> <span>Pengeluaran</span> <span class="pull-right-container">
                      <i class="fa fa-angle-left pull-right"></i>
                    </span> </a>
                        <ul class="treeview-menu">
                            <li>
                                <router-link to="/pengeluaran_harian"> Harian</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_cogs"> Bulanan COGS</router-link>
                            </li>
                            <li>
                                <router-link to="/pengeluaran_bulanan_opr"> Bulanan OPR</router-link>
                            </li>
                        </ul>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/saving"> <i class="ti-wallet"></i> <span>Saving</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/laporan_harian"> <i class="ti-write"></i> <span>Laporan</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/pnl"> <i class="ti-bar-chart"></i> <span>PnL</span> </router-link>
                    </li>
					<li v-if="level.indexOf('AM') !== -1">
                        <router-link to="/toko_dashboard"> <i class="ti-pie-chart"></i> <span>Dashboard</span> </router-link>
                    </li>

                </ul>
                <div style="height: 200px;"></div>
            </section>
            <!-- /.sidebar -->
        </div>
    </aside>
</template>
<script>
import Vue from 'vue'
import Avatar from 'vue-avatar'
import VueCookie from 'vue-cookie'
Vue.use(VueCookie)
export default {
  name: 'DashboardSidebar',
  data: function () {
    return {
      username: '',
      level: ''
    }
  },
  mounted: function () {
    this.level = localStorage.level
    $(document).ready(function ($) {
      $('.main-sidebar > div').slimScroll({
        width: '230px',
        position: 'left',
        size: '5px',
        height: '95vh'
      })
    })
    console.log('level=', localStorage.level)
    if (!localStorage.level) this.$router.replace('/login')
  },
  watch: {
    '$route': function (to, from) {
      if (localStorage.level) {
        this.level = localStorage.level
      }
    }
  },
  components: {
    Avatar
  }
}
</script>
<style>
    .sidebar {
        overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// Sidebar.vue?eae246a2